<template>
    <div>
        <v-layout row wrap>
            <v-flex xs12 sm6>
                <v-card v-if="isShow.coWorker">
                    <v-card-title>協力者</v-card-title>
                    <v-card-text>
                        <p v-for="(c, i) in comments.coWorker" :key="i">
                            ・{{c.trim()}}
                        </p>
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex xs12 sm6>
                <v-card v-if="isShow.subject">
                    <v-card-title>本人</v-card-title>
                    <v-card-text>
                        <p v-for="(c, i) in comments.subject" :key="i">
                            ・{{c.trim()}}
                        </p>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </div>
</template>
<script>
export default {
    components: {},
    props: {
        isShow: null,
        comments: null
    },
    data() {
        return {
        }
    },
}
</script>